<template>
  <div class="muselet muselet__wrapper">
    <div class="muselet__dot" ref="musletdot">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 600" class="muselet">
        <defs>
          <filter id="blurred">
            <feGaussianBlur in="SourceGraphic" stdDeviation="5" />
          </filter>

          <clipPath id="clip-path__image" clipPathUnits="userSpaceOnUse">
            <path d="M189.4,567.8c-77.8-18.6-138.5-79.4-157.2-157.2c-42.2-67.9-42.2-153.9,0-221.8C50.9,111,111.6,50.3,189.4,31.6c67.9-42.2,153.9-42.2,221.8,0C489,50.2,549.8,111,568.4,188.8c42.2,67.9,42.2,153.9,0,221.8c-18.6,77.8-79.4,138.5-157.2,157.2C343.1,609.2,257.5,609.3,189.4,567.8z" fill-rule="evenodd" fill="#FFD300" class="muselet__path muselet__path--first" filter="url(#blurred)"/>
          </clipPath>
        </defs>
        <path d="M189.4,567.8c-77.8-18.6-138.5-79.4-157.2-157.2c-42.2-67.9-42.2-153.9,0-221.8C50.9,111,111.6,50.3,189.4,31.6c67.9-42.2,153.9-42.2,221.8,0C489,50.2,549.8,111,568.4,188.8c42.2,67.9,42.2,153.9,0,221.8c-18.6,77.8-79.4,138.5-157.2,157.2C343.1,609.2,257.5,609.3,189.4,567.8z" fill-rule="evenodd" fill="#FFD300" class="muselet__path muselet__path--first" />
        <!-- <path d="m159.789634,536.100822c-38.94018,-22.992237 -69.571704,-54.378128 -92.999562,-92.840188a227.298026,227.298026 0 0 1 -23.778478,-53.783135a50.850669,50.850669 0 0 0 -6.14118,-13.397972c-21.090384,-32.639627 -33.160246,-68.137346 -34.700853,-107.236899c-1.529983,-38.738307 7.713662,-74.37415 28.793421,-106.854403a18.986658,18.986658 0 0 0 2.390598,-5.811809c14.279837,-56.758101 49.83068,-94.880165 103.18882,-117.234909a197.261494,197.261494 0 0 1 42.191393,-12.367359c10.231758,-1.795604 18.859159,-7.86241 28.46405,-11.442994c45.686978,-16.999806 91.8627,-18.965408 138.452792,-4.249951a172.197406,172.197406 0 0 1 49.41631,25.35096a24.766592,24.766592 0 0 0 6.906171,3.824956c47.960702,15.692946 85.551522,45.261982 115.152433,85.732145a262.986993,262.986993 0 0 1 38.345187,74.777895a18.678536,18.678536 0 0 0 2.454347,4.664322c25.032214,36.209586 38.844556,76.169754 39.184552,120.326749c0.265622,33.659615 -7.054919,65.693624 -23.374733,95.400784a36.007713,36.007713 0 0 0 -3.623084,9.902387c-13.387347,62.11304 -49.703182,105.643167 -107.364397,131.557246a149.810787,149.810787 0 0 1 -35.572093,10.51863a35.380845,35.380845 0 0 0 -9.944886,3.48496c-50.425673,25.244711 -102.445079,29.74966 -155.941342,11.262371a199.747716,199.747716 0 0 1 -52.805646,-28.092179a38.887055,38.887055 0 0 0 -10.731127,-5.652435a198.780852,198.780852 0 0 1 -30.408402,-13.695468c-2.433097,-1.540607 -5.195566,-2.475597 -7.554289,-4.143703z" fill-rule="evenodd" fill="none" class="muselet__path muselet__path--last"/> -->
        <path d="M168 523c-36.8-21.7-65.7-51.3-87.8-87.7-9.6-15.9-17.1-32.8-22.4-50.8-1.3-4.5-3.2-8.7-5.8-12.6-20-30.8-31.3-64.3-32.8-101.2-1.4-36.6 7.3-70.2 27.2-100.9 1.2-1.7 1.7-3.6 2.3-5.5 13.5-53.7 47-89.6 97.5-110.7 12.8-5.4 26.1-9.2 39.9-11.7 9.6-1.7 17.8-7.4 26.9-10.8 43.2-16.1 86.8-17.9 130.7-4 16.9 5.3 32.4 13.5 46.6 23.9 2 1.4 4 2.8 6.5 3.7 45.3 14.8 80.8 42.8 108.7 80.9 15.8 21.7 27.9 45.1 36.2 70.6.5 1.5 1.3 3.1 2.3 4.4 23.6 34.2 36.7 72 37 113.7.3 31.8-6.6 62-22.1 90.1-1.6 3-2.7 6.1-3.4 9.3-12.6 58.7-46.9 99.8-101.4 124.3-10.7 4.8-22.1 7.9-33.6 9.9-3.4.6-6.4 1.8-9.4 3.3-47.6 23.7-96.7 28-147.3 10.5-17.9-6.2-34.5-15.3-49.9-26.5-3.2-2.3-6.5-4.1-10.1-5.3-10-3.4-19.5-8-28.8-12.9-2.1-1.6-4.7-2.5-7-4z" fill-rule="evenodd" fill="none" class="muselet__path muselet__path--last"/>
        <!-- <path d="M95.4,500.5c-65.8-48.8-77.5-86.8-91.3-165.6c-12.3-70.7,16.8-97,27.4-153.9C45.9,102.4,89.8,56.1,167.5,37.6c68.2-42.3,227.6-38,295.1,4.2c77.7,18.5,98.9,139.7,127.4,214.4c27.6,72.2-4.2,125.3-70.1,239.9c-39.7,69.2-141,77.7-220.8,76.4C134.8,569.9,117,520.7,95.4,500.5z" fill-rule="evenodd" fill="none" class="muselet__path muselet__path--last" /> -->
      </svg>

      <div class="composition-cont" v-if="$route.name ==='home' && !isMobile()" style="opacity: 0">
        <img class="image-fade" :src="`/static/img/composition/${index}.jpg`" :style="{ zIndex: index === 0 ? 35 : 0 }" alt="composition image" v-for="(numb, index) in 35" :key="index" />
      </div>

      <div class="logo-winary" v-if="!isMobile()"></div>

    </div>
    <Logo class="logo-container" />
  </div>
</template>

<script>
import { TweenMax, Linear, Power1 } from 'gsap/TweenMax';
import MorphSVGPlugin from '@/assets/lib/gsap-bonus/MorphSVGPlugin'; //eslint-disable-line
import { mapGetters } from 'vuex';

import { qs, qsa, isMobile } from '@/scripts/utils';

import Logo from '@/components/Logo';


export default {
  name: 'Muselet',

  data() {
    return {
      isMobile,
    };
  },

  components: {
    Logo,
  },

  computed: {
    ...mapGetters({
      loaded: 'getPageLoaded',
    }),
  },

  mounted() {
    if (!isMobile()) TweenMax.set('.muselet__dot', { scale: 0.3 });

    this.morphMuslet();

    this.$eventHub.$on('windowResized', this.setPosition);
  },

  methods: {
    morphMuslet() {
      const first = qsa('.muselet__path--first', this.$el);
      const last = qs('.muselet__path--last', this.$el);

      TweenMax.to(first, 4, {
        morphSVG: last,
        repeat: -1,
        yoyo: true,
        ease: Power1.easeInOut,
        delay: 6,
      });

      TweenMax.to(first, 50, {
        rotation: '360',
        repeat: -1,
        transformOrigin: '50% 50%',
        ease: Linear.easeNone,
        delay: 6,
      });
    },

    setPosition() {
      // if (window.innerWidth > 1280) return;
      if (!this.loaded) return;

      const muselet = this.$refs.musletdot;

      const contW = document.querySelector('[js-pagecontainer]').getBoundingClientRect().width;
      const contH = document.querySelector('[js-pagecontainer]').getBoundingClientRect().height;
      const windowW = window.innerWidth;

      const tXa = (windowW <= 767 || this.$store.state.route.name === 'home') ? 0 :
        (contW - (muselet.getBoundingClientRect().width)) / 2;

      const tYa = (windowW <= 767 && this.$store.state.route.name !== 'home') ? ((contH - (muselet.getBoundingClientRect().height * 1.4)) / 2) + (muselet.getBoundingClientRect().height) : 0; // eslint-disable-line

      let scaleP = 1;
      if (this.$store.state.route.name !== 'home') {
        scaleP = (windowW <= 767) ? 1.4 : 0.8;
      }

      TweenMax.to(muselet, 0.8, {
        x: tXa,
        y: -tYa,
        scale: scaleP,
        transformOrigin: '50% 50%',
        ease: Power1.easeInOut,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../application';


.muselet {
  &__wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;

    @extend %flex;
    align-items: center;
    justify-content: center;

    @include mq(sm) {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow: visible;
    }

    [js-view="event"] & {
      position: absolute;
    }
  }

  &__dot {
    position: relative;
    width: 90%;

    @include mq(sm) {
      width: 600px;
    }
    z-index: -1;
  }

   @at-root {
    .nite .muselet__path--first {
      fill: $color-secondary;
    }
  }

  .composition-cont {
    display: inline-block;
    position: absolute;
    width: 100%;
    height: 100%;

    clip-path: url(#clip-path__image);

    pointer-events: none;

    border-radius: 50%; // fix ms
    overflow: hidden; // fix ms

    @at-root .cssclippathinset & {
      border-radius: 0;
      overflow: visible;
    }
  }

  img {
    position: absolute;
    bottom: 0;
    width: 100%;
  }

  .logo-winary {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background-image: url("/static/vector/logo.svg");
    background-size: 50%;
    background-position: center center;
    background-repeat: no-repeat;
  }

  .composition-cont {
    display: inline-block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    clip-path: url(#clip-path__image);

    img {
      position: absolute;
      width: 100%;
      bottom: 0;

      z-index: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Muselet.vue